/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Country } from '../models/country';
import { getManyBaseCountryControllerCountry } from '../fn/country/get-many-base-country-controller-country';
import { GetManyBaseCountryControllerCountry$Params } from '../fn/country/get-many-base-country-controller-country';
import { GetManyCountryResponseDto } from '../models/get-many-country-response-dto';
import { getOneBaseCountryControllerCountry } from '../fn/country/get-one-base-country-controller-country';
import { GetOneBaseCountryControllerCountry$Params } from '../fn/country/get-one-base-country-controller-country';

@Injectable({ providedIn: 'root' })
export class CountryApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseCountryControllerCountry()` */
  static readonly GetManyBaseCountryControllerCountryPath = '/api/countries';

  /**
   * Retrieve multiple Countries.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseCountryControllerCountry()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseCountryControllerCountry$Response(params?: GetManyBaseCountryControllerCountry$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyCountryResponseDto>> {
    const obs = getManyBaseCountryControllerCountry(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Countries.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseCountryControllerCountry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseCountryControllerCountry(params?: GetManyBaseCountryControllerCountry$Params, context?: HttpContext): Observable<GetManyCountryResponseDto> {
    const resp = this.getManyBaseCountryControllerCountry$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyCountryResponseDto>): GetManyCountryResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseCountryControllerCountry()` */
  static readonly GetOneBaseCountryControllerCountryPath = '/api/countries/{id}';

  /**
   * Retrieve a single Country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseCountryControllerCountry()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseCountryControllerCountry$Response(params: GetOneBaseCountryControllerCountry$Params, context?: HttpContext): Observable<StrictHttpResponse<Country>> {
    const obs = getOneBaseCountryControllerCountry(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseCountryControllerCountry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseCountryControllerCountry(params: GetOneBaseCountryControllerCountry$Params, context?: HttpContext): Observable<Country> {
    const resp = this.getOneBaseCountryControllerCountry$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Country>): Country => r.body)
    );
  }

}
